/**
@ngdoc directive
@name legacyJqueryObserve

@description
Observe ng model and fire callback whenever it's changes.

@usage
<input type="hidden" legacy-jquery-watch="formModel.field" callback="yourFunction()" />
<!-- (it doesn't need to be hidden input, can be any element) -->

*/

(function() {
    'use strict';

    var legacyJqueryWatch = function() {
        return {
            restrict: "A",
            scope: {
               ngModel: "&legacyJqueryWatch",
               callback:"@"
            },
            replace: false,
            transclude: false,
            link: function(scope, element, attrs) {

                scope.$watch(
                    function(){
                        return scope.ngModel();
                    },
                    function(newVal, oldVal){
                        if(newVal!=oldVal){
                            eval(scope.callback);
                        }
                    },
                    true // deep watch
                );

            }

        };
    }
    angular.module('app').directive('legacyJqueryWatch', legacyJqueryWatch);

}());